import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatINR(val: number | string = 0, fixedDecimals = false): string {
  const num = Number(val) || 0;
  const hasDecimals = num % 1 !== 0 || fixedDecimals;
  return `₹${num.toLocaleString("en-IN", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}


/** Short rupee amounts for dense views: ₹4.82 Cr, ₹38.6 L, ₹85,000 */
export function formatINRCompact(val: number | string = 0): string {
  const n = Number(val) || 0;
  const abs = Math.abs(n);
  const trim = (x: number, d: number) => x.toFixed(d).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1");
  if (abs >= 1e7) return `₹${trim(n / 1e7, 2)} Cr`;
  if (abs >= 1e5) return `₹${trim(n / 1e5, 1)} L`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}
